import { render, staticRenderFns } from "./Wishlist.vue?vue&type=template&id=1cc9b34a&scoped=true&"
import script from "./Wishlist.vue?vue&type=script&lang=js&"
export * from "./Wishlist.vue?vue&type=script&lang=js&"
import style0 from "./Wishlist.vue?vue&type=style&index=0&id=1cc9b34a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc9b34a",
  null
  
)

export default component.exports